export default __webpack_public_path__ + "static/media/milestone-tier-4.98fc7c58.png";